import { api } from './api';

export interface ShipmentChargesUploadResponse {
  message: string;
  totalRows: number;
  validShipments: number;
  invalidTrackingNumbers: string[];
}

export const shipmentChargesService = {
  async uploadShipmentCharges(formData: FormData): Promise<ShipmentChargesUploadResponse> {
    const { data } = await api.post<ShipmentChargesUploadResponse>(
      '/shipment/charges/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return data;
  },
};
